import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { hideWidgetErrorModal } from '@mm/state/actions/networkActions';
import './../../../editor/features/build/components/modals/Modal.scss';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import './WidgetErrorModal.pcss';
import { WIDGET_ERROR_MODAL_TITLE } from './constants';

type config = {
  message: string;
  show: boolean;
};

type Handlers = {
  hideModal: () => void;
};

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Handlers;

const WidgetErrorModal = ({ config, hideModal }: Props) => {
  const closeButtonText = 'Ok';

  return (
    <Modal isOpen={config.show} className="network-error-modal">
      <ModalHeader className="general-text-modal__header">
        {WIDGET_ERROR_MODAL_TITLE}
      </ModalHeader>
      <ModalBody className="general-text-modal__body">
        {config.message}
      </ModalBody>
      <ModalFooter className="general-text-modal__footer">
        <Button
          className="general-text-modal__close-button"
          onClick={hideModal}
        >
          {closeButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state: StoreState) => ({
  config: state.network.widgetErrorModal,
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  hide: () => {
    dispatch(hideWidgetErrorModal());
  },
});

const hideModal =
  ({ hide }) =>
  () => {
    hide();
  };

const enhance = compose<Props, {}>(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({ hideModal }),
);

export default enhance(WidgetErrorModal);
